/*
 * PortUNA Framework (http://www.portuna.de/)
 *
 * @author     Grandke, Luke <grandke@portuna.de>
 * @copyright  PortUNA Neue Medien GmbH (http://www.portuna.de)
 * @created    17.9.2024 9:28 Uhr
 */

import {exportEnabled, exportSettings} from '@/library/export';
import {uniqueId} from '@/library/string';
import store from '@/store';
import {TinyEmitter} from 'tiny-emitter';
import {computed, getCurrentInstance, onMounted, onUpdated, ref} from 'vue';

export function usePortuna()
{
    const root = ref<HTMLElement>();

    onMounted(() =>
    {
        const currentInstance = getCurrentInstance();

        if (currentInstance?.proxy?.$el && (currentInstance?.exposeProxy || currentInstance?.exposed))
        {
            const instance = currentInstance?.proxy?.$el;

            instance.__vue__ = currentInstance?.exposeProxy || currentInstance?.exposed;

            if (instance.__vue__ && !instance.__vue__.$emit)
            {
                instance.__vue__.$emit = currentInstance?.emit;
            }
        }
    });

    onUpdated(() =>
    {
        const currentInstance = getCurrentInstance();

        if (currentInstance?.proxy?.$el && !currentInstance?.proxy?.$el.hasOwnProperty('__vue__'))
        {
            const instance = currentInstance?.proxy?.$el;

            instance.__vue__ = currentInstance?.exposeProxy || currentInstance?.exposed;

            if (instance.__vue__ && !instance.__vue__.$emit)
            {
                instance.__vue__.$emit = currentInstance?.emit;
            }
        }
    });

    const emitter = new TinyEmitter();
    const _uid    = uniqueId();

    const currentUser = computed<CurrentUser>(() =>
    {
        return store.state.layoutData.user;
    });

    const currentExportSettings = computed<Partial<InternalExportData>>(() =>
    {
        return exportSettings();
    });

    const isExportRequest = computed<boolean>(() =>
    {
        return exportEnabled();
    });

    let viewSize = store.state.viewSize;

    return {
        root,
        emitter,
        currentUser,
        currentExportSettings,
        isExportRequest,
        _uid,
        viewSize,
    };
}